import {create} from 'zustand';

import {createSelectors} from '@/config/zustand/selectorGenerator';
import {type Notification} from '@/gql-codegen/generated';

type State = {
  notifications?: Notification;
  addNotification: (notification?: Notification) => void;
  clearNotifications: () => void;
};

export const NotificationStore = create<State>(set => ({
  notifications: undefined,
  addNotification: notification =>
    set(() => ({
      notifications: notification,
    })),
  clearNotifications: () => set({notifications: undefined}),
}));

export const useNotificationStore = createSelectors(NotificationStore);
